import { config } from "core/utils";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
var useTerm = function (callback, showSearch) {
    var _a = useState(""), term = _a[0], setTerm = _a[1];
    var debounce = useDebouncedCallback(function (filter) {
        setTerm(filter);
        if (filter.length >= config.search.threshold)
            callback(filter);
    }, config.search.delay);
    useEffect(function () {
        if (!showSearch)
            setTerm("");
    }, [showSearch]);
    return { term: term, debounce: debounce };
};
export default useTerm;
